module.exports = __webpack_public_path__ + "static/img/coming-soon.45dd0c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coming-soon.svg
// module id = M94x
// module chunks = 1